import { node } from 'prop-types'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import './node_modules/@rebrandly/styleguide/dist/index.css'
import './src/styles/normalize.css'
import './src/styles/components.css'
import './src/styles/global.css'
import './src/styles/tooltip.css'
import './src/styles/common.css'
import './src/styles/lightbox.css'

const WrapRootElement = ({ element }) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      scriptProps={{
        async: false,
        defer: false,
        appendTo: 'head'
      }}
    >
      {element}
    </GoogleReCaptchaProvider>
  )
}

WrapRootElement.propTypes = {
  element: node
}

export const wrapRootElement = WrapRootElement

export const onClientEntry = () => {
  window.addEventListener('load', () => {
    document.body.className = document.body.className.replace(/\bno-js\b/, '')
  })

  if (typeof window !== 'undefined') {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://app.termly.io/embed.min.js'
    script.setAttribute('data-auto-block', 'off')
    script.setAttribute('data-website-uuid', '61bb2db1-af48-413b-92ac-290a30774ccb')

    script.onload = () => {
      const checkTermly = setInterval(() => {
        if (window.Termly) {
          clearInterval(checkTermly)

          window.Termly.on('initialized', () => {
            window.dispatchEvent(new Event('termly_loaded'))
          })

          window.Termly.on('consent', () => {
            window.dispatchEvent(new Event('termly_consent_changed'))
          })
        }
      }, 100)
    }

    document.head.appendChild(script)
  }
}
